import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Button } from '@/components/ui/button';
    import { Plus } from 'lucide-vue-next';

export default /*@__PURE__*/_defineComponent({
  __name: 'AddButton',
  setup(__props) {

    
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Button), {
    variant: "ghost",
    size: "sm"
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", null, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _createVNode(_unref(Plus), { class: "text-accent" })
    ]),
    _: 3
  }))
}
}

})